"use client";

import { cn } from "@/lib/utils";
import { memo } from "react";
import Carousel, { CarouselSlide } from "@/components/ui/carousel";
import { SupportCardsCarouselProps } from "./types";
import SupportCard from "../SupportCard";

const SupportCardsCarousel = ({
  className,
  cards,
  imageCardRatioBoost = false,
  responsive = true,
}: SupportCardsCarouselProps) => {
  return (
    <Carousel.Mobile
      options={{
        slides: {
          spacing: 24,
          perView: "auto",
        },
      }}
      showPagination
      className={cn(
        "md:mt-0 md:!grid md:!grid-cols-3 md:!gap-4 !overflow-visible",
        className
      )}
    >
      {cards.map(({ title, imageUrl, description, href, linkLabel }, idx) => (
        <CarouselSlide
          key={idx}
          className="!min-w-[74%] !w-[74%] !md:min-w-auto !w-auto"
        >
          <SupportCard
            title={title}
            imageUrl={imageUrl}
            description={description}
            href={href}
            linkLabel={linkLabel}
            imageRatioBoost={imageCardRatioBoost}
            responsive={responsive}
          />
        </CarouselSlide>
      ))}
    </Carousel.Mobile>
  );
};

export default memo(SupportCardsCarousel);
